import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { Component, Fragment } from 'react';
import { Card, Cell } from '@vinted/web-ui';
import uuid from 'uuid';
import { withBreakpoint } from 'components/Breakpoint';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

class Banner extends Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "renderActions", () => {
      const {
        actions
      } = this.props;
      if (!(actions !== null && actions !== void 0 && actions.length)) return null;
      return /*#__PURE__*/_jsx("div", {
        className: "banner-actions__container",
        children: actions.map(action => /*#__PURE__*/_jsx(Fragment, {
          children: action
        }, uuid.v4()))
      });
    });
  }

  renderBanner() {
    const {
      title,
      body,
      prefix,
      children,
      breakpoints,
      highlighted
    } = this.props;
    const suffix = this.renderActions();
    const content = children || body;
    return /*#__PURE__*/_jsxs(Cell, {
      styling: Cell.Styling.Tight,
      highlighted: highlighted,
      children: [/*#__PURE__*/_jsxs(Cell, {
        prefix: prefix,
        suffix: breakpoints.phones ? null : suffix,
        highlighted: highlighted,
        children: [title && /*#__PURE__*/_jsx("div", {
          children: title
        }), content && /*#__PURE__*/_jsx("div", {
          children: content
        })]
      }), !!suffix && /*#__PURE__*/_jsx("div", {
        className: "u-phones-only u-ui-margin-horizontal-large u-ui-margin-bottom-large",
        children: suffix
      })]
    });
  }

  render() {
    const {
      breakpoints
    } = this.props;

    if (breakpoints.phones) {
      return this.renderBanner();
    }

    return /*#__PURE__*/_jsx("div", {
      className: "u-fill-width",
      children: /*#__PURE__*/_jsx(Card, {
        children: /*#__PURE__*/_jsx("div", {
          className: "u-overflow-hidden",
          children: this.renderBanner()
        })
      })
    });
  }

}

export default withBreakpoint(Banner);